import { Link } from 'react-router-dom';
import { Mail, MessageCircle } from 'lucide-react';
import { StaticPageLayout } from '../../components/shopper/StaticPageLayout';
import { Card, CardContent } from '../../components/ui/card';
import { CONTACT, CONTACT_INQUIRIES } from '../../content/site-pages';
import { ROUTES } from '../../constants/routes';

export function ContactPage() {
  return (
    <StaticPageLayout title="Contact Us" subtitle={CONTACT.responseTime}>
      <Card>
        <CardContent className="p-5 space-y-4">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0">
              <Mail className="h-5 w-5 text-blue-600" />
            </div>
            <div>
              <p className="font-medium text-heading text-sm">General support</p>
              <a
                href={`mailto:${CONTACT.supportEmail}`}
                className="text-sm text-primary hover:underline"
              >
                {CONTACT.supportEmail}
              </a>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center flex-shrink-0">
              <MessageCircle className="h-5 w-5 text-green-600" />
            </div>
            <div>
              <p className="font-medium text-heading text-sm">Live chat</p>
              <p className="text-sm text-body">Coming soon</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <div>
        <h2 className="text-sm font-medium text-body uppercase tracking-wider mb-3 px-1">
          How can we help?
        </h2>
        <Card>
          <CardContent className="p-0 divide-y divide-gray-100">
            {CONTACT_INQUIRIES.map((inquiry) => (
              <a
                key={inquiry.label}
                href={`mailto:${inquiry.email}?subject=${encodeURIComponent(inquiry.label)}`}
                className="block p-4 hover:bg-gray-50 transition-colors"
              >
                <p className="font-medium text-heading text-sm">{inquiry.label}</p>
                <p className="text-sm text-body mt-1">{inquiry.description}</p>
                <p className="text-xs text-primary mt-2">{inquiry.email}</p>
              </a>
            ))}
          </CardContent>
        </Card>
      </div>

      <p className="text-sm text-body text-center">
        Many common questions are answered in our{' '}
        <Link to={ROUTES.faq} className="text-primary hover:underline">
          FAQ
        </Link>
        , including{' '}
        <Link to={ROUTES.shipping} className="text-primary hover:underline">
          shipping
        </Link>{' '}
        and{' '}
        <Link to={ROUTES.returns} className="text-primary hover:underline">
          returns
        </Link>
        .
      </p>
    </StaticPageLayout>
  );
}
